"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VAR_PATTERNS = exports.ENV_VAR_PREFIX = exports.SPECIAL_PATH_VARS = void 0;
/**
 * Special path variables
 */
exports.SPECIAL_PATH_VARS = {
    HOME: ['$HOMEPATH', '$~'],
    PROJECT: ['$PROJECTPATH', '$.']
};
/**
 * Environment variable prefix
 */
exports.ENV_VAR_PREFIX = 'ENV_';
/**
 * Variable reference patterns
 */
exports.VAR_PATTERNS = {
    TEXT: /\${([^}]+)}/,
    DATA: /#{([^}]+)}/,
    PATH: /\$([A-Za-z0-9_~]+)/,
    FORMAT: />>\(([^)]+)\)/
};
